import { useMemo } from 'react'
import { useImageOrganizeActions, useImageOrganizeModes } from '../../../views/imageBrowse/hooks'
import { getUpdateDividersSection } from '../../../views/imageBrowse/helpers'
import useViewMode from '../../../views/imageBrowse/hooks/useViewMode'

export default function useSections() {
  const { viewMode } = useViewMode()
  const { isDivideMode } = useImageOrganizeModes()

  const { dividerOffsets, removeDivider } = useImageOrganizeActions()
  const updateDividersSections = getUpdateDividersSection({ dividerOffsets, removeDivider })
  const dividedSections = getUpdateDividersSection({ dividerOffsets })

  const sections = useMemo(() => {
    let sectionsValue
    if (isDivideMode) sectionsValue = updateDividersSections
    else if (viewMode === 'group') sectionsValue = dividedSections
    if (sectionsValue?.length > 0) return sectionsValue
    return [{ offset: 0 }]
  }, [dividedSections, isDivideMode, updateDividersSections, viewMode])

  return sections
}
